import React from "react";

const HomeLayout = ({ children, ...rest }) => {

    return (
        <div>
            <header>
                <div className="logo">
                    <img src="/img/logo.png" alt="" />
                </div>
            </header>
            <main>
                {children}
            </main>
            <footer>
                <p>Impulsado por MORANT - © 2024 - Todos los derechos reservados</p>
            </footer>
        </div>
    );
};
export default HomeLayout;
